module.exports = __webpack_public_path__ + "images/mistergreenc1dbc010b9ae95bdb5e5e401c1a7ec51.png";